// extracted by css-extract-rspack-plugin
export default {"spinnerWrapper":"_4f1c3686","loadMore":"_559c283b","button":"_7124ffe","spinner":"_3c264035","reviewBodyWrapper":"_71934751","reviewsModalBody":"_d873cfda","compact":"_ce27bb4f"};